let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kpoiF")).then(() => parcelRequire('7wy1U'));